export default {
    setSelectedReceiptLogUnit(state, receiptLogUnit) {
        state.selectedReceiptLogUnit = receiptLogUnit;
    },
};
